import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { filterSpeakersWithProgramSessions } from '../../../data/filters/speakers/filterSpeakersWithProgramSessions';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useEventSpeakers } from '../../../data/hooks/speakers/useEventSpeakers';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';
import RelativeRedirect from '../../elements/RelativeRedirect/RelativeRedirect';
import SearchBar from '../../elements/SearchBar/SearchBar3';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Screen from '../Screen';
import SimpleSpeakersList from './lists/SimpleSpeakersList/SimpleSpeakersList';

function EventSpeakers(props) {
    const {} = props,
        { eventId } = useParams(),
        event = useEvent(eventId),
        { show_speakers_list } = useEventSettings(event.id),
        i18n = useI18n(),
        [textFilter, setTextFilter] = useState(''),
        speakers = useEventSpeakers(event.id, {
            filter: filterSpeakersWithProgramSessions,
        }),
        filteredSpeakers = useMemo(() => {
            let result = speakers;

            if (textFilter?.length) {
                const expr = new RegExp(textFilter, 'ig');
                result = result.filter((s) => expr.test(s.name));
            }

            return result;
        }, [textFilter, speakers]);

    const header = (
        <div>
            <TopBarEvent event={event} returnURL="..">
                {i18n['label.speakers']}
            </TopBarEvent>
            <hr />
            <SearchBar value={textFilter} i18n={i18n} disableFilterButton onTextChange={setTextFilter} />
        </div>
    );

    if (!speakers.length) return <RelativeRedirect to=".." />;
    if (!show_speakers_list) return <RelativeRedirect to=".." />;

    return (
        <Screen header={header}>
            {/* <AlphabeticalSpeakersList speakers={filteredSpeakers} savePositionKey={'eventSpeakers-' + eventId} /> */}
            <SimpleSpeakersList speakers={filteredSpeakers} savePositionKey={'eventSpeakers-' + eventId} />
        </Screen>
    );
}

export default EventSpeakers;
